<template>
  <el-card style="height: 100%" class="box-card">
    <div slot="header" class="clearfix">
      <!-- 标题 -->
      <el-row>
        <el-col :span="15">
          <span style="font-size: 24px">图纸资料</span>
          <div class="head-text" style="float: right; margin-top: 0px">
            <!-- 新建事件 -->
            <el-input v-model="query" placeholder="请输入文件名称关键词" class="search-input" style="width: 300px"></el-input>
            <el-button @click="GetDrwingFileList" slot="append" icon="el-icon-search"
              style="margin-right: 40px"></el-button>
          </div>
        </el-col>
        <el-col :span="9">
          <el-row>
            <el-col :span="4">
              <el-select filterable v-model="value" placeholder="请选择" @change="selectChange">
                <el-option label="全部" value="1"></el-option>
                <el-option label="我上传的" value="3"></el-option>
                <el-option label="我收藏的" value="2"></el-option>
              </el-select>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button v-if="value == 3" style="width: 100%" @click="MoveFile2" type="primary">移动</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button v-if="
                ($store.state.permissions != null &&
                  $store.state.permissions.includes('1053')) ||
                $store.state.isProject
              " style="width: 100%" type="primary" @click="dialogVisible3Open">分享</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button style="width: 100%" type="primary" @click="dialogVisible2Open">分享管理</el-button>
            </el-col>
            <el-col :span="4" :offset="1">
              <el-button v-if="
                $store.state.permissions != null &&
                $store.state.permissions.includes('1052') ||
                $store.state.isProject
              " style="width: 100%" type="danger" @click="deletefile">批量删除</el-button>
            </el-col>
          </el-row>
        </el-col>
      </el-row>
    </div>
    <el-container>
      <el-aside width="200px" style="
          border: 1px solid #dcdfe6;
          border-radius: 4px;
          height: 100%;
          text-align: center;
        " class="elAside">
        <el-button type="primary" size="small" @click="showAll">显示全部图纸</el-button>
        <div class="zTreeDiv">
          <ul id="ProjectFileTree" class="ztree"></ul>
        </div>
        <div id="dataListRemenu" v-if="
          ($store.state.permissions != null &&
            $store.state.permissions.includes('1541')) ||
          $store.state.isProject
        ">
          <ul>
            <li id="addDataList">新增图纸</li>
          </ul>
        </div>
      </el-aside>
      <el-main>
        <div class="rygl-table">
          <el-table ref="multipleTable" :data="tableData" tooltip-effect="dark" style="width: 100%" height="72vh"
            @selection-change="handleSelectionChange" v-loading="tableLoading">
            <el-table-column align="center" type="selection" width="55"></el-table-column>
            <el-table-column align="center" type="index" label="序号"></el-table-column>
            <el-table-column align="center" width="200px" prop="name" label="图纸名称" sortable>
              <template slot-scope="scope">
                <el-button style="width: 100%" @click="ViewDrawings(scope.row.pjdr01)" :title="scope.row.pjdr03">{{
                  scope.row.pjdr03.length > 10
                    ? scope.row.pjdr03.substr(0, 10) + "..."
                    : scope.row.pjdr03
                }}</el-button>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="pjdr06" label="大小（MB）"></el-table-column>
            <el-table-column align="center" prop="user04" label="上传用户"></el-table-column>
            <el-table-column align="center" prop="pjdr08" label="上传时间"></el-table-column>
            <el-table-column align="center" prop="pjdr09" label="可见范围">
              <template slot-scope="scope">
                <span>{{ scope.row.pjdr09 == 1 ? "公开" : "部分可见" }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="pjdr09" label="转换状态">
              <template slot-scope="scope">
                <span>{{
                  scope.row.pjdr10 == 0
                    ? "未转换"
                    : scope.row.pjdr10 == 1
                      ? "转换中"
                      : "已转换"
                }}</span>
              </template>
            </el-table-column>
            <el-table-column align="center" prop="name" label="操作" width="280">
              <template slot-scope="scope">
                <el-button size="small" plain type="primary" style="cursor: pointer"
                  @click="CollectionFile2(scope.row)">{{
                    scope.row.Collection == true ? "取消收藏" : "收藏"
                  }}</el-button>
                <el-button size="small" plain type="primary" style="cursor: pointer"
                  @click="updataSee(scope.row.pjdr01)">修改</el-button>
                <el-button size="small" plain type="primary" style="cursor: pointer"
                  @click="download(scope.row.pjdr04, scope.row.pjdr03)" v-if="
                    ($store.state.permissions != null &&
                      $store.state.permissions.includes('1054')) ||
                    $store.state.isProject
                  ">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination style="margin-top: 20px" align="center" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" :current-page="pagenum" :page-sizes="[100, 50, 10]"
          :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </el-main>
    </el-container>
    <!-- 新增 -->
    <el-dialog :close-on-click-modal="false" title="新增图纸" :visible.sync="dialogVisible" width="40%">
      <el-row>
        <el-col :span="12">
          <el-upload class="upload-demo" ref="upload" :action="actionUrl" :before-upload="handleBefore"
            :file-list="fileList" :auto-upload="false" accept=".dwg" :data="aaa" multiple="" :headers="importHeaders"
            :on-success="handleSuccess">
            <el-button slot="trigger" size="small" type="primary">选取文件</el-button>
            <div slot="tip" class="el-upload__tip">
              只能上传dwg文件，且不超过50MB
            </div>
          </el-upload>
        </el-col>
        <el-col :span="12">
          可见设置：
          <el-radio v-model="radio" :label="1">公开</el-radio>
          <el-radio v-model="radio" :label="2">半公开</el-radio>
          <div style="
              border: 2px solid #eee;
              height: 200px;
              max-height: 200px;
              overflow: auto;
              width: 80%;
              box-sizing: border-box;
            " v-if="radio == 2">
            <el-row style="padding: 10px">
              <el-col :span="8" v-for="(item, index) in multipleSelection2" :key="index" style="padding-top: 10px">
                <el-row style="padding: 0px">
                  <el-col :span="20">{{ item.user04 }}</el-col>
                  <el-col :span="4">
                    <span style="color: red; cursor: pointer" @click="delectUser(index)">x</span>
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
          <el-button type="primary" size="small" style="margin: 10px" v-if="radio == 2"
            @click="dialogVisible1OPen">添加</el-button>
        </el-col>
      </el-row>
      <el-row style="height: 80px">
        <el-col :span="3" :offset="8">
          <el-button type="primary" style="width: 100%" @click="submitUpload">上传</el-button>
        </el-col>
        <el-col :span="3" :offset="1">
          <el-button type="primary" style="width: 100%" @click="dialogVisible = false">取消</el-button>
        </el-col>
      </el-row>
    </el-dialog>
    <!-- 项目下的人员列表 -->
    <el-dialog :close-on-click-modal="false" title="请选择人员" :visible.sync="dialogVisible1" width="25%">
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input v-model="selectName" placeholder="请输入名称" class="search-input" style="width: 95%"></el-input>
        <el-button @click="dialogVisible1OPen" slot="append" icon="el-icon-search"></el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData3" tooltip-effect="dark" style="width: 100%" max-height="400"
        @selection-change="handleSelectionChange2">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index" label="序号" width="100"></el-table-column>
        <el-table-column prop="user02" label="帐号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <div style="width: 100%; height: 40px; margin-top: 10px; text-align: center">
        <el-button type="primary" size="small" @click="dialogVisible1 = false">确定</el-button>
      </div>
    </el-dialog>
    <!-- 请选择人员 -->
    <el-dialog :close-on-click-modal="false" title="请选择人员" :visible.sync="dialogVisible5" width="25%">
      <div class="head-text">
        <!-- 新建事件 -->
        <el-input v-model="selectName2" placeholder="请输入名称" class="search-input"></el-input>
        <el-button @click="dialogVisible5OPen" slot="append" icon="el-icon-search"></el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData4" tooltip-effect="dark" style="width: 100%" max-height="400"
        @selection-change="handleSelectionChange3">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column type="index"></el-table-column>
        <el-table-column prop="user02" label="帐号"></el-table-column>
        <el-table-column prop="user04" label="姓名"></el-table-column>
      </el-table>
      <el-row style="height: 80px; text-align: center">
        <el-button type="primary" @click="dialogVisible5True">确定</el-button>
      </el-row>
    </el-dialog>
    <!-- 分享管理 -->
    <el-dialog :close-on-click-modal="false" title="分享管理" :visible.sync="dialogVisible2" width="40%">
      <div>
        <!-- 新建事件 -->
        <el-input placeholder="请输入文件名称关键词" v-model="query2" style="width: 90%"></el-input>
        <el-button slot="append" @click="dialogVisible2Open" icon="el-icon-search"></el-button>
      </div>
      <el-table ref="multipleTable" :data="tableData2" tooltip-effect="dark" style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="pjdr03" width="200" label="文件名称"></el-table-column>
        <el-table-column prop="OverTime" label="剩余天数"></el-table-column>
        <el-table-column prop="name" width="300px" label="操作">
          <template slot-scope="scope">
            <el-button type="success" @click="CopyList(scope.row)">复制链接</el-button>
            <el-button type="danger" @click="DelFileLink2(scope.row)">取消分享</el-button>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="分享资料" :visible.sync="dialogVisible3" width="40%" height="30%">
      <el-card class="box-card" style="padding: 20px; box-sizing: border-box">
        分享期限：
        <el-radio v-model="radio2" :label="1">1天</el-radio>
        <el-radio v-model="radio2" :label="7">7天</el-radio>
        <el-radio v-model="radio2" :label="30">30天</el-radio>
        <el-radio v-model="radio2" :label="null">永久有限</el-radio>
        <el-row style="margin-top: 50px">
          <el-col :span="6" :offset="6">
            <el-button type="primary" style="width: 100%" @click="ShareFile2">确定</el-button>
          </el-col>
          <el-col :span="6">
            <el-button type="danger" style="width: 100%" @click="dialogVisible3 = false">取消</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>
    <!-- 修改可见 -->
    <el-dialog :close-on-click-modal="false" title="修改可见" :visible.sync="dialogVisible4" width="40%">
      <div>
        可见设置：
        <el-radio @change="radioChang" v-model="radio3" :label="1">公开</el-radio>
        <el-radio @change="radioChang" v-model="radio3" :label="2">半公开</el-radio>
        <div style="
            border: 2px solid #eee;
            height: 200px;
            overflow: auto;
            width: 80%;
            margin: 10px;
            box-sizing: border-box;
          " v-if="radio3 == 2">
          <el-row>
            <el-col :span="6" v-for="(item, index) in multipleSelection3" :key="index">
              <el-row>
                <el-col :span="20">{{ item.user04 }}</el-col>
                <el-col :span="4">
                  <span style="color: red; cursor: pointer" @click="delectUser2(item.user01)">x</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
        <el-button type="primary" v-if="radio3 == 2" style="margin: 10px" @click="dialogVisible5OPen">添加</el-button>
      </div>
    </el-dialog>
    <!-- 移动 -->
    <el-dialog :close-on-click-modal="false" title="移动分组" :visible.sync="dialogVisible6" width="40%">
      <el-card class="box-cord">
        <el-table ref="singleTable" :data="TreeData" highlight-current-row @current-change="handleCurrentChange2"
          style="width: 100%; margin-bottom: 20px" default-expand-all row-key="pjdt01" border
          :tree-props="{ children: 'children', hasChildren: 'hasChildren' }">
          <el-table-column type="index" width="50"></el-table-column>
          <el-table-column property="label" label="名称"></el-table-column>
        </el-table>
        <el-row>
          <el-col :span="6" :offset="6">
            <el-button type="primary" @click="MoveFileTrue">确定</el-button>
          </el-col>
          <el-col :span="6">
            <el-button type="danger" @click="dialogVisible6 = false">取消</el-button>
          </el-col>
        </el-row>
      </el-card>
    </el-dialog>

    <el-dialog :close-on-click-modal="false" title="图纸展示" :visible.sync="drawingsIsShow" width="70%">
      <div id="modelShow"></div>
    </el-dialog>
  </el-card>
</template>

<script>
import { download } from "@/tools/tool";
import {
  Getpdrwaingtree,
  GetDrwingFileList,
  DelDrwingFile,
  GetShareDrawingList,
  DelDrawingLink,
  ShareDrawing,
  CollectionDrawing,
  MoveFile,
  GetDrawingWhitOutUserList,
  DelCollectDrawing,
  GetDrawingWhitUserList,
  DelDrawingWhitUser,
  AddDrawingUser,
  ChangeDrawingState,
  ViewDrawings,
  TransformDrawings,
} from "@/setAxios.js";
import Clipboard from "clipboard";
export default {
  name: "dataList",
  data() {
    return {
      drawingsIsShow: false,
      actionUrl: this.$store.state.baseUrl + "/api/UploadDrawingFile",
      currentRow: null,
      fid: "",
      url2: "",
      url1: "",
      gid: "",
      importHeaders: { token: localStorage.getItem("token") },
      fileList: [],
      query: "",
      query2: "",
      radio: 1,
      radio2: 1,
      radio3: "",
      pagesize: 10,
      pagesize2: 10,
      pagenum: 1,
      pagenum2: 1,
      total: 0,
      total2: 0,
      value: "1",
      selectName: "",
      selectName2: "",
      TreeData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      tableData: [],
      tableLoading: false,
      tableData2: [],
      tableData3: [],
      tableData4: [],
      multipleSelection: [],
      multipleSelection2: [],
      multipleSelection3: [],
      multipleSelection4: [],
      isClick: false,
      dialogVisible: false,
      dialogVisible1: false,
      dialogVisible2: false,
      dialogVisible3: false,
      dialogVisible4: false,
      dialogVisible5: false,
      dialogVisible6: false,
      aaa: {
        uid: localStorage.getItem("id"),
        Uids: "",
        xid: localStorage.getItem("xid"),
        type: 1,
        ids: "",
        qid: localStorage.getItem("pid"),
      },
      tips: null,
    };
  },
  created() { },
  mounted() {
    this.getData();
  },
  methods: {
    async ViewDrawings(id) {
      this.tips = null;
      var res = await ViewDrawings({ id });
      if (res.Code == 0) {
        this.tips = this.$notify({
          message: res.Message,
          duration: 0,
          type: "success",
        });
        let params = {
          qid: localStorage.pid,
          id,
        };
        var res = await TransformDrawings(params);
        if (res.Code == 0) {
          this.$message({
            type: "warning",
            message: res.Message,
          });
          this.tips.close();
        } else {
          this.$notify({
            message: res.Message,
            type: "success",
          });
          this.tips.close();
          this.showModel(res.Data.pjdr11);
        }
      } else if (res.Code == 1) {
        this.$message({
          message: res.Message,
          type: "warning",
        });
      } else if (res.Code == 2) {
        this.showModel(res.Data.pjdr11);
      }
    },
    showModel(url) {
      this.drawingsIsShow = true;
      this.$nextTick(() => {
        var _this = this;
        var config = {
          disabledExtensions: {
            measure: false,
            section: false,
          },
          memory: {
            limit: 32 * 1024, //32 GB
          },
          theme: "light-theme",
        };
        var element = document.getElementById("modelShow");
        _this.viewer = new Autodesk.Viewing.Private.GuiViewer3D(
          element,
          config
        );
        var options = {
          docid: this.$store.state.baseUrl + url,
          env: "Local",
          offline: "true",
          useADP: false,
        };

        Autodesk.Viewing.Initializer(options, function () {
          _this.viewer.start();
          _this.viewer.loadModel(options.docid, {
            isAEC: true,
          });
          _this.viewer.addEventListener(
            Autodesk.Viewing.GEOMETRY_LOADED_EVENT,
            function () {
              // _this.$message({
              //   type: "success",
              //   message: "模型加载完成",
              // });
            }
          );
        });
      });
    },
    //下载
    download(url, name) {
      download(this.$store.state.baseUrl + url, name);
    },
    // 查看关联
    seeAssociated(row) {
      this.$router.push({
        name: "associated",
        params: {
          docId: row.pjdr01,
          name: row.pjdr03,
        },
      });
    },
    // 移动
    MoveFile2() {
      if (this.multipleSelection.length > 0) {
        this.dialogVisible6 = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先做选择",
        });
      }
    },
    MoveFileTrue() {
      let fids = [];
      this.multipleSelection.forEach((ele) => {
        fids.push(ele.pjdr01);
      });
      fids = fids.join(",");
      let params = {
        fid: fids,
        gid: this.currentRow.pjdt01,
      };
      this.$confirm("是否移动该资料?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        MoveFile(params).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "移动成功",
            });
            this.dialogVisible6 = false;
            this.getData();
          }
        });
      });
    },
    radioChang(data) {
      let params = {
        fid: this.fid,
        type: data,
      };
      ChangeDrawingState({ ...params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "更改成功",
          });
        }
      });
    },
    dialogVisible5True() {
      let uids = [];
      this.multipleSelection4.forEach((ele) => {
        uids.push(ele.user01);
      });
      let params = {
        uids: uids.join(","),
        fid: this.fid,
      };
      AddDrawingUser({ ...params }).then((res) => {
        //(res);
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "添加成功",
          });
          this.dialogVisible4 = false;
          this.dialogVisible5 = false;
        }
      });
    },
    updataSee(fid) {
      this.dialogVisible4 = true;
      this.fid = fid;
      let params = {
        fid: fid,
        xid: localStorage.getItem("xid"),
      };
      GetDrawingWhitUserList({ params }).then((res) => {
        this.multipleSelection3 = res.Data.list;
        this.radio3 = res.Data.type;
      });
    },
    // 删除
    deletefile() {
      if (this.multipleSelection.length > 0) {
        let fids = [];
        this.multipleSelection.forEach((ele) => {
          fids.push(ele.pjdr01);
        });
        fids = fids.join(",");
        //(fids);
        this.$confirm("是否删除该资料目录?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            DelDrwingFile({ fids }).then((res) => {
              //(res);
              if (res.Code > 0) {
                this.$message({
                  type: "success",
                  message: "删除成功",
                });
              } else {
                this.$message({
                  type: "warning",
                  message: "删除失败",
                });
              }
              this.getData();
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      } else {
        this.$message({
          type: "warning",
          message: "请选择",
        });
      }
    },
    CopyList(row) {
      this.url2 = this.url1 + row.code;
      //(this.url2);
      this.copyToClip(this.url2);
    },
    copyToClip(content, message) {
      var aux = document.createElement("input");
      aux.setAttribute("value", content);
      document.body.appendChild(aux);
      aux.select();
      document.execCommand("copy");
      document.body.removeChild(aux);
      if (message == null) {
        this.$message({
          type: "success",
          message: "恭喜你复制成功",
        });
      } else {
        alert(message);
      }
    },
    handleSuccess(response, file, fileList) {
      if (response.Code > 0) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.dialogVisible = false;
        this.getData();
      } else {
        this.$message({
          type: "error",
          message: response.Message,
        });
        this.dialogVisible = false;
        this.getData();
      }
    },
    delectUser(index) {
      //(index);

      this.multipleSelection2.splice(index, 1);
      this.$message({
        type: "success",
        message: "删除成功",
      });
    },
    delectUser2(id) {
      let params = {
        uid: id,
        fid: this.fid,
      };
      DelDrawingWhitUser({ ...params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "删除成功",
          });
          this.updataSee(this.fid);
        }
      });
    },
    dialogVisible1OPen() {
      this.dialogVisible1 = true;
      let params = {
        searchword: this.selectName,
        fid: 0,
        xid: localStorage.getItem("xid"),
      };
      GetDrawingWhitOutUserList({ params }).then((res) => {
        this.tableData3 = res.Data.list;
        this.selectName = "";
      });
    },
    dialogVisible5OPen() {
      this.dialogVisible5 = true;
      let params = {
        searchword: this.selectName2,
        fid: this.fid,
        xid: localStorage.getItem("xid"),
      };
      GetDrawingWhitOutUserList({ params }).then((res) => {
        this.tableData4 = res.Data.list;
      });
    },
    // 新增
    dialogVisibleOpen() {
      if (this.isClick == false) {
        this.$message({
          type: "warning",
          message: "请先选择",
        });
      } else {
        this.dialogVisible = true;
      }
    },
    // 收藏
    CollectionFile2(row) {
      let params = {
        fid: row.pjdr01,
        uid: localStorage.getItem("id"),
      };
      if (row.Collection) {
        DelCollectDrawing({ ...params }).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "取消收藏成功",
            });
            this.getData();
          }
        });
      } else {
        CollectionDrawing({ ...params }).then((res) => {
          if (res.Code > 0) {
            this.$message({
              type: "success",
              message: "收藏成功",
            });
            this.getData();
          }
        });
      }
    },
    // 分享
    ShareFile2() {
      let fids = [];
      this.multipleSelection.forEach((element) => {
        fids.push(element.pjdr01);
      });
      let params = {
        fids: fids.join(","),
        days: this.radio2,
        uid: localStorage.getItem("id"),
      };
      ShareDrawing({ ...params }).then((res) => {
        if (res.Code > 0) {
          this.$message({
            type: "success",
            message: "分享成功",
          });
          this.dialogVisible3 = false;
        }
      });
    },
    dialogVisible3Open() {
      if (this.multipleSelection.length > 0) {
        this.dialogVisible3 = true;
      } else {
        this.$message({
          type: "warning",
          message: "请先做选择",
        });
      }
    },
    dialogVisible2Open() {
      this.dialogVisible2 = true;
      let params = {
        seachword: this.query2,
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        pageIndex: this.pagenum2,
        pageSize: this.pagesize2,
      };
      GetShareDrawingList({ params }).then((res) => {
        //(res);
        this.tableData2 = res.Data.list;
        this.url1 = res.Data.url;
      });
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleBefore(file) {
      if (
        file.name.split(".")[file.name.split(".").length - 1].toLowerCase() !=
        "dwg"
      ) {
        this.$message.error("只能上传dwg格式文件");
        return false;
      }
      if (file.size / 1024 / 1024 > 50) {
        this.$message.error("不能超过50M");
        return false;
      }
      let fd = new FormData();
      this.aaa.type = this.radio;
      let userID = [];
      this.multipleSelection2.forEach((ele) => {
        userID.push(ele.user01);
      });
      this.aaa.Uids = userID.join(",");
      fd.append("file", file);
      fd.append("model", this.aaa);
    },
    getData() {
      let params = {
        xid: localStorage.getItem("xid"),
      };
      Getpdrwaingtree({ params }).then((res) => {
        this.TreeData = res.Data;
        this.init();
      });
    },
    GetDrwingFileList() {
      let params2 = {
        seachword: this.query,
        xid: localStorage.getItem("xid"),
        uid: localStorage.getItem("id"),
        gid: this.aaa.ids,
        type: this.aaa.type,
        pageIndex: this.pagenum,
        pageSize: this.pagesize,
      };
      this.tableLoading = true;
      GetDrwingFileList({ params: params2 }).then((res) => {
        this.tableLoading = false;
        this.total = res.Data.total;
        this.tableData = res.Data.list;
      });
    },
    showAll() {
      this.aaa.ids = "null";
      this.GetDrwingFileList();
    },
    //初始化ztree
    init() {
      var _this = this;

      var setting = {
        view: {
          selectedMulti: false,
        },
        check: {
          enable: true,
        },
        data: {
          key: {
            name: "pjdt02",
          },
          simpleData: {
            enable: true,
            idKey: "pjdt01",
            pIdKey: "pjdt03",
          },
        },
        callback: {
          onCheck: onCheck,
          onClick: onclick,
          onRightClick: OnRightClick,
        },
      };
      // 在ztree上的右击事件
      function OnRightClick(event, treeId, treeNode) {
        _this.selectNode = treeNode;
        if (treeNode == null) {
          showRMenu("root", event.clientX, event.clientY);
        } else {
          _this.aaa.gid = treeNode.pjdt01;
          showRMenu("node", event.clientX, event.clientY);
        }
      }
      //鼠标按下事件
      function onBodyMouseDown(event) {
        if (
          !(
            event.target.id == "dataListRemenu" ||
            $(event.target).parents("#dataListRemenu").length > 0
          )
        ) {
          $("#dataListRemenu").css({ visibility: "hidden" });
        }
      }
      //显示右键菜单
      function showRMenu(type, x, y) {
        if (type != "root") {
          $("#dataListRemenu").show();
          $("#addDataList").show();
          $("#dataListRemenu").css({
            top: y + "px",
            left: x + "px",
            visibility: "visible",
          }); //设置右键菜单的位置、可见
          $("body").bind("mousedown", onBodyMouseDown);
        }
      }

      $("#dataListRemenu ul li")
        .unbind()
        .bind("click", function () {
          $("#dataListRemenu").css({
            visibility: "hidden",
          });
          var type = $(this).attr("id");
          if (type == "addDataList") {
            _this.dialogVisible = true;
          }
        });

      this.zTeeObj = $.fn.zTree.init(
        $("#ProjectFileTree"),
        setting,
        this.TreeData
      );
      this.TreeData.forEach((d) => {
        var node = _this.zTeeObj.getNodeByParam("pjdt01", d.pjdt01);
        if (node != null) {
          this.zTeeObj.checkNode(node, true, true);
        }
      });

      var checkedNodes = this.zTeeObj.getCheckedNodes();
      _this.aaa.ids = "";
      var _split = "";
      checkedNodes.forEach((element) => {
        _this.aaa.ids += _split + element.pjdt01;
        _split = ",";
      });
      _this.GetDrwingFileList();
      // 选中状态
      function onCheck() {
        var checkedNodes = _this.zTeeObj.getCheckedNodes();
        _this.aaa.ids = "";
        var _split = "";
        checkedNodes.forEach((element) => {
          _this.aaa.ids += _split + element.pjdt01;
          _split = ",";
        });
        _this.GetDrwingFileList();
      }

      //点击事件
      function onclick(event, treeId, treeNode) {
        _this.aaa.ids = treeNode.pjdt01;
        _this.GetDrwingFileList();
      }
    },
    removeNull(arr) {
      arr.forEach((ele) => {
        if (ele.children == undefined)
          return
        if (ele.children.length == 0) {
          delete ele.children;
        } else {
          this.removeNull(ele.children);
        }
      });
    },
    // 取消分享
    DelFileLink2(row) {
      let params = {
        flid: row.drlk01,
      };
      DelDrawingLink({ ...params }).then((res) => {
        //(res);
        if (res.Code == 1) {
          this.$message({
            type: "success",
            message: "取消成功",
          });
          this.dialogVisible2Open();
        }
      });
    },
    selectChange(data) {
      //(data);
      this.aaa.type = data;
      this.getData();
      //(data);
    },
    handleNodeClick(data) {
      //(data);
      this.aaa.gid = data.pjdt01;
      this.isClick = true;
      this.GetDrwingFileList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChange2(val) {
      this.multipleSelection2 = val;
    },
    handleSelectionChange3(val) {
      this.multipleSelection4 = val;
    },
    handleSizeChange(val) {
      this.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.pagenum = val;
      this.getData();
    },
    handleCurrentChange2(val) {
      this.currentRow = val;
    },
  },
};
</script>

<style lang="less" scoped>
div#dataListRemenu {
  position: fixed;
  visibility: hidden;
  top: 0;
  width: 60px;
  background-color: #35a5db;
  padding: 4px;
  border-radius: 3px;
  overflow: auto;
  border: 1px solid #eee;
}

div#dataListRemenu ul {
  margin: 0px;
  padding: 0px;
}

div#dataListRemenu ul li {
  font-size: 12px;
  line-height: 20px;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
  list-style: none outside none; //取消样式
  background-color: rgba(255, 255, 255, 0);
  padding-left: 3px;
  margin: 1px auto;
  color: white;
  border-radius: 3px;
  letter-spacing: 1px;
}

div#dataListRemenu ul li:hover {
  background: #eee;
  color: #000000;
}

#ProjectFileTree {
  height: 500px;
}

.zTreeDiv {
  overflow: auto;
}

.ztree li span {
  line-height: 21px;
  margin-right: 2px;
}

.userManagement .search-input {
  width: 300px;
}

#modelShow {
  width: 90%;
  margin-left: 5%;
  position: relative;
  height: 600px;
  // display: inline-flex;
}
</style>
